import { render, staticRenderFns } from "./SpaceHost.vue?vue&type=template&id=45c1e12e&scoped=true&"
import script from "./SpaceHost.vue?vue&type=script&lang=js&"
export * from "./SpaceHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c1e12e",
  null
  
)

export default component.exports